import React from 'react';
import { AiOutlineCalendar, AiOutlineStock } from 'react-icons/ai';
import { FiEdit } from 'react-icons/fi';
import { BsKanban } from 'react-icons/bs';
import { BiMeteor, BiTrophy } from 'react-icons/bi';
import { IoMdCalendar, IoMdContacts } from 'react-icons/io';
import { RiContactsLine } from 'react-icons/ri';
import { MdComputer, MdOutlineSportsBasketball } from 'react-icons/md';



export const kanbanGrid = [
  { headerText: 'To Do',
    keyField: 'Open',
    allowToggle: true },

  { headerText: 'In Progress',
    keyField: 'InProgress',
    allowToggle: true },

  { headerText: 'Done',
    keyField: 'Close',
    allowToggle: true },
];

export const links = [
  {
    title: 'Dashboard',
    links: [
      {
        name: 'Home',
        icon: <RiContactsLine />,
      },
    ],
  },

  {
    title: 'Pages',
    links: [
      {
        name: 'Create Event',
        icon: <FiEdit />,
      },
      {
        name: 'Event History',
        icon: <AiOutlineStock />,
      },
      {
        name: 'Upcoming Events',
        icon: <IoMdCalendar />,
      },
      {
        name: 'Attendees',
        icon: <IoMdContacts />,
      },
    ],
  },
  {
    title: ' Apps',
    links: [
      {
        name: 'Calendar',
        icon: <AiOutlineCalendar />,
      },
      {
        name: 'Worklist',
        icon: <BsKanban />,
      },
      
    ],
  },
  
];

export const featureddata = [
  {
    icon: <MdComputer />,
    amount: 'CSCI 461',
    percentage: 'Pioch 115',
    title: '11:00 Am',
    iconColor: '#03C9D7',
    iconBg: '#E5FAFB',
    pcColor: 'red-600',
  },
  {
    icon: <MdOutlineSportsBasketball />,
    amount: 'SPST 455',
    percentage: 'Basil 232',
    title: '2:30 Pm',
    iconColor: 'rgb(255, 244, 229)',
    iconBg: 'rgb(254, 201, 15)',
    pcColor: 'green-600',
  },
  {
    icon: <BiMeteor/>,
    amount: 'Teddy Dance For Love',
    percentage: 'Nursing 100',
    title: '6:00 pm',
    iconColor: 'rgb(228, 106, 118)',
    iconBg: 'rgb(255, 244, 229)',

    pcColor: 'green-600',
  },
  {
    icon: <BiTrophy />,
    amount: 'Womens Lax Game vs Oswego',
    percentage: 'Growney Stadium',
    title: '7:00 pm',
    iconColor: 'rgb(0, 194, 146)',
    iconBg: 'rgb(235, 250, 242)',
    pcColor: 'red-600',
  },
];

export const themeColors = [
  {
    name: 'blue-theme',
    color: '#1A97F5',
  },
  {
    name: 'green-theme',
    color: '#03C9D7',
  },
  {
    name: 'purple-theme',
    color: '#7352FF',
  },
  {
    name: 'red-theme',
    color: '#FF5C8E',
  },
  {
    name: 'indigo-theme',
    color: '#1E4DB7',
  },
  {
    color: '#FB9678',
    name: 'orange-theme',
  },
];

export const upcomingGrid = [
  {
    field: 'EventID',
    headerText: 'Event Id',
    textAlign: 'Center',
    width: '120',
  },
  {
    field: 'EventName',
    headerText: 'Event Name',
    width: '150',
    editType: 'dropdownedit',
    textAlign: 'Center',
  },
  { field: 'Date',
    headerText: 'Date',
    width: '150',
    textAlign: 'Center',
  },
  {
    field: 'StartTime',
    headerText: 'Start Time',
    textAlign: 'Center',
    width: '150',
  },
  {
    headerText: 'EndTime',
    field: 'End Time',
    textAlign: 'Center',
    width: '120',
  },
  {
    field: 'Location',
    headerText: 'Location',
    editType: 'dropdownedit',
    width: '120',
    textAlign: 'Center',
  },

  {
    field: 'Creator',
    headerText: 'Creator',
    width: '150',
    editType: 'dropdownedit',
    textAlign: 'Center',
  },
];

export const attendeeData = [
  {
    UserID: 1,
    Name: 'Nancy Davolio',
    Email: 'ncd111@sjfc.edc',
    DateJoined: '01/01/2021',
    CheckInTime: '11:30:10',
    Phone: '(111)-111-1111',
  },
  {
    UserID: 2,
    Name: 'Nasimiyu Danai',
    Email: 'nsd111@sjfc.edc',
    DateJoined: '01/02/2021',
    CheckInTime: '11:30:12',
    Phone: '(111)-111-2222',
  },
  {
    UserID: 3,
    Name: 'Iulia Albu',
    Email: 'ica111@sjfc.edc',
    DateJoined: '01/03/2021',
    CheckInTime: '11:30:14',
    Phone: '(111)-111-3333',
  },
  {
    UserID: 4,
    Name: 'Siegbert Gottfried',
    Email: 'sdg111@sjfc.edc',
    DateJoined: '01/01/2021',
    CheckInTime: '11:30:16',
    Phone: '(111)-111-4444',
  },
  {
    UserID: 5,
    Name: 'Kyle Darobe',
    Email: 'kfd05520@sjfc.edc',
    DateJoined: '01/02/2021',
    CheckInTime: '11:30:18',
    Phone: '(111)-111-5555',
    
  },
  {
    UserID: 6,
    Name: 'Maddie Inyene',
    Email: 'mfi111@sjfc.edc',
    DateJoined: '01/03/2021',
    CheckInTime: '11:30:12',
    Phone: '(111)-111-6666',
  },
  {
    UserID: 7,
    Name: 'Miron Vitold',
    Email: 'dmz05520@sjfc.edc',
    DateJoined: '01/04/2021',
    CheckInTime: '11:30:10',
    Phone: '(111)-111-7777',
  },
  {
    UserID: 8,
    Name: 'Carry Davolio',
    Email: 'cvd1111@sjfc.edc',
    DateJoined: '01/05/2021',
    CheckInTime: '11:30:16',
    Phone: '(111)-111-8888',
  },
  {
    UserID: 9,
    Name: 'Jacob Danai',
    Email: 'jed111@sjfc.edc',
    DateJoined: '01/06/2021',
    CheckInTime: '11:30:18',
    Phone: '(111)-111-9999',
  },
  {
    UserID: 10,
    Name: 'Iulia Elbu',
    Email: 'ipe1110@sjfc.edc',
    DateJoined: '01/04/2021',
    CheckInTime: '11:30:14',
    Phone: '(111)-222-0000',
  },
  {
    UserID: 11,
    Name: 'Camille Gottfried',
    Email: 'clg111@sjfc.edc',
    DateJoined: '01/06/2021',
    CheckInTime: '11:30:13',
    Phone: '(111)-222-1111',
  },
  {
    UserID: 12,
    Name: 'Omar Darobe',
    Email: 'osd1110@sjfc.edc',
    DateJoined: '01/05/2021',
    CheckInTime: '11:30:36',
    Phone: '(111)-222-2222',
  },
  {
    UserID: 13,
    Name: 'Penjani Inyene',
    Email: 'pci111@sjfc.edc',
    DateJoined: '01/10/2021',
    CheckInTime: '11:30:52',
    Phone: '(111)-222-3333',
  },
  {
    UserID: 14,
    Name: 'Miron Titold',
    Email: 'mwt111@sjfc.edc',
    DateJoined: '01/15/2021',
    CheckInTime: '11:30:59',
    Phone: '(111)-222-4444',
  },
  {
    UserID: 15,
    Name: 'Nancy Savolio',
    Email: 'nks111@sjfc.edc',
    DateJoined: '01/29/2021',
    CheckInTime: '11:30:46',
    Phone: '(111)-222-5555',
  },
  {
    UserID: 16,
    Name: 'Nancy Davolio',
    Email: 'ncd111@sjfc.edc',
    DateJoined: '01/01/2021',
    CheckInTime: '11:30:10',
    Phone: '(111)-111-1111',
  },
  {
    UserID: 17,
    Name: 'Nasimiyu Danai',
    Email: 'nsd111@sjfc.edc',
    DateJoined: '01/02/2021',
    CheckInTime: '11:30:12',
    Phone: '(111)-111-2222',
  },
  {
    UserID: 18,
    Name: 'Iulia Albu',
    Email: 'ica111@sjfc.edc',
    DateJoined: '01/03/2021',
    CheckInTime: '11:30:14',
    Phone: '(111)-111-3333',
  },
  {
    UserID: 19,
    Name: 'Siegbert Gottfried',
    Email: 'sdg111@sjfc.edc',
    DateJoined: '01/01/2021',
    CheckInTime: '11:30:16',
    Phone: '(111)-111-4444',
  },
  {
    UserID: 20,
    Name: 'Kyle Darobe',
    Email: 'kfd05520@sjfc.edc',
    DateJoined: '01/02/2021',
    CheckInTime: '11:30:18',
    Phone: '(111)-111-5555',
    
  },
  {
    UserID: 21,
    Name: 'Maddie Inyene',
    Email: 'mfi111@sjfc.edc',
    DateJoined: '01/03/2021',
    CheckInTime: '11:30:12',
    Phone: '(111)-111-6666',
  },
  {
    UserID: 22,
    Name: 'Miron Vitold',
    Email: 'dmz05520@sjfc.edc',
    DateJoined: '01/04/2021',
    CheckInTime: '11:30:10',
    Phone: '(111)-111-7777',
  },
  {
    UserID: 23,
    Name: 'Carry Davolio',
    Email: 'cvd1111@sjfc.edc',
    DateJoined: '01/05/2021',
    CheckInTime: '11:30:16',
    Phone: '(111)-111-8888',
  },
  {
    UserID: 24,
    Name: 'Jacob Danai',
    Email: 'jed111@sjfc.edc',
    DateJoined: '01/06/2021',
    CheckInTime: '11:30:18',
    Phone: '(111)-111-9999',
  },
  {
    UserID: 25,
    Name: 'Iulia Elbu',
    Email: 'ipe1110@sjfc.edc',
    DateJoined: '01/04/2021',
    CheckInTime: '11:30:14',
    Phone: '(111)-222-0000',
  },
  {
    UserID: 26,
    Name: 'Camille Gottfried',
    Email: 'clg111@sjfc.edc',
    DateJoined: '01/06/2021',
    CheckInTime: '11:30:13',
    Phone: '(111)-222-1111',
  },
  {
    UserID: 27,
    Name: 'Omar Darobe',
    Email: 'osd1110@sjfc.edc',
    DateJoined: '01/05/2021',
    CheckInTime: '11:30:36',
    Phone: '(111)-222-2222',
  },
  {
    UserID: 28,
    Name: 'Penjani Inyene',
    Email: 'pci111@sjfc.edc',
    DateJoined: '01/10/2021',
    CheckInTime: '11:30:52',
    Phone: '(111)-222-3333',
  },
  {
    UserID: 29,
    Name: 'Miron Titold',
    Email: 'mwt111@sjfc.edc',
    DateJoined: '01/15/2021',
    CheckInTime: '11:30:59',
    Phone: '(111)-222-4444',
  },
  {
    UserID: 30,
    Name: 'Nancy Savolio',
    Email: 'nks111@sjfc.edc',
    DateJoined: '01/29/2021',
    CheckInTime: '11:30:46',
    Phone: '(111)-222-5555',
  },
];

export const historyData = [
  {
    EventID: '10001',
    EventName: 'SPST 141',
    StartTime:'11:30',
    Date: '03/02/2023',
    Location: 'Basil 121',
    EndTime: '12:30',
  },
{
    EventID: '10002',
    EventName: 'CSCI 461',
    StartTime:'3:30',
    Date: '03/03/2023',
    Location: 'Pioch 118',
    EndTime: '4:30',
  },
{
    EventID: '10003',
    EventName: 'CSCI 161',
    StartTime:'8:30',
    Date: '03/03/2023',
    Location: 'Pioch 131',
    EndTime: '9:30',
  },
{
    EventID: '10004',
    EventName: 'SPST 422',
    StartTime:'6:30',
    Date: '03/02/2023',
    Location: 'Basil 213',
    EndTime: '9:30',
  },
  {
    EventID: '10005',
    EventName: 'Mens Basketball vs Nazreth',
    StartTime:'7:00',
    Date: '03/04/2023',
    Location: 'Growney Gym',
    EndTime: '9:30',
  },
  {
    EventID: '10006',
    EventName: 'SPST 141',
    StartTime:'11:30',
    Date: '03/09/2023',
    Location: 'Basil 121',
    EndTime: '12:30',
  },
{
    EventID: '10007',
    EventName: 'CSCI 461',
    StartTime:'3:30',
    Date: '03/10/2023',
    Location: 'Pioch 118',
    EndTime: '4:30',
  },
{
    EventID: '10008',
    EventName: 'CSCI 161',
    StartTime:'8:30',
    Date: '03/10/2023',
    Location: 'Pioch 131',
    EndTime: '9:30',
  },
{
    EventID: '10009',
    EventName: 'SPST 422',
    StartTime:'6:30',
    Date: '03/09/2023',
    Location: 'Basil 213',
    EndTime: '9:30',
  },
  {
    EventID: '10010',
    EventName: 'Womens volleyball vs Buffalo',
    StartTime:'7:00',
    Date: '03/04/2023',
    Location: 'Growney Gym',
    EndTime: '9:30',
  },
  {
    EventID: '10011',
    EventName: 'ENGL 141',
    StartTime:'1:30',
    Date: '03/02/2023',
    Location: 'Basil 121',
    EndTime: '2:30',
  },
{
    EventID: '10012',
    EventName: 'PHIL 461',
    StartTime:'2:15',
    Date: '03/03/2023',
    Location: 'Pioch 118',
    EndTime: '3:15',
  },
{
    EventID: '10013',
    EventName: 'ENGL 161',
    StartTime:'9:45',
    Date: '03/03/2023',
    Location: 'Pioch 131',
    EndTime: '10:45',
  },
{
    EventID: '10014',
    EventName: 'PHIL 422',
    StartTime:'5:15',
    Date: '03/02/2023',
    Location: 'Basil 213',
    EndTime: '6:15',
  },
  {
    EventID: '10015',
    EventName: 'Mens Basketball vs Cortland',
    StartTime:'7:00',
    Date: '03/04/2023',
    Location: 'Growney Gym',
    EndTime: '9:30',
  },
  {
    EventID: '10016',
    EventName: 'ENGL 141',
    StartTime:'1:30',
    Date: '03/09/2023',
    Location: 'Basil 121',
    EndTime: '2:30',
  },
{
    EventID: '10017',
    EventName: 'PHIL 461',
    StartTime:'2:15',
    Date: '03/10/2023',
    Location: 'Pioch 118',
    EndTime: '3:15',
  },
{
    EventID: '10018',
    EventName: 'ENGL 161',
    StartTime:'9:45',
    Date: '03/10/2023',
    Location: 'Pioch 131',
    EndTime: '10:45',
  },
{
    EventID: '10019',
    EventName: 'PHIL 422',
    StartTime:'5:10',
    Date: '03/09/2023',
    Location: 'Basil 213',
    EndTime: '6:15',
  },
  {
    EventID: '10020',
    EventName: 'Womens volleyball vs Morrisville',
    StartTime:'7:00',
    Date: '03/08/2023',
    Location: 'Growney Gym',
    EndTime: '9:30',
  },
];

export const upcomingData = [
  {
    EventID: '10001',
    EventName: 'SPST 141',
    StartTime:'11:30',
    Date: '05/02/2023',
    Location: 'Basil 121',
    EndTime: '12:30',
  },
{
    EventID: '10002',
    EventName: 'CSCI 461',
    StartTime:'3:30',
    Date: '05/03/2023',
    Location: 'Pioch 118',
    EndTime: '4:30',
  },
{
    EventID: '10003',
    EventName: 'CSCI 161',
    StartTime:'8:30',
    Date: '05/03/2023',
    Location: 'Pioch 131',
    EndTime: '9:30',
  },
{
    EventID: '10004',
    EventName: 'SPST 422',
    StartTime:'6:30',
    Date: '05/02/2023',
    Location: 'Basil 213',
    EndTime: '9:30',
  },
  {
    EventID: '10005',
    EventName: 'Mens Basketball vs Nazreth',
    StartTime:'7:00',
    Date: '05/04/2023',
    Location: 'Growney Gym',
    EndTime: '9:30',
  },
  {
    EventID: '10006',
    EventName: 'SPST 141',
    StartTime:'11:30',
    Date: '05/09/2023',
    Location: 'Basil 121',
    EndTime: '12:30',
  },
{
    EventID: '10007',
    EventName: 'CSCI 461',
    StartTime:'3:30',
    Date: '05/10/2023',
    Location: 'Pioch 118',
    EndTime: '4:30',
  },
{
    EventID: '10008',
    EventName: 'CSCI 161',
    StartTime:'8:30',
    Date: '05/10/2023',
    Location: 'Pioch 131',
    EndTime: '9:30',
  },
{
    EventID: '10009',
    EventName: 'SPST 422',
    StartTime:'6:30',
    Date: '05/09/2023',
    Location: 'Basil 213',
    EndTime: '9:30',
  },
  {
    EventID: '10010',
    EventName: 'Womens volleyball vs Buffalo',
    StartTime:'7:00',
    Date: '05/04/2023',
    Location: 'Growney Gym',
    EndTime: '9:30',
  },
  {
    EventID: '10011',
    EventName: 'ENGL 141',
    StartTime:'1:30',
    Date: '05/02/2023',
    Location: 'Basil 121',
    EndTime: '2:30',
  },
{
    EventID: '10012',
    EventName: 'PHIL 461',
    StartTime:'2:15',
    Date: '05/03/2023',
    Location: 'Pioch 118',
    EndTime: '3:15',
  },
{
    EventID: '10013',
    EventName: 'ENGL 161',
    StartTime:'9:45',
    Date: '05/03/2023',
    Location: 'Pioch 131',
    EndTime: '10:45',
  },
{
    EventID: '10014',
    EventName: 'PHIL 422',
    StartTime:'5:15',
    Date: '05/02/2023',
    Location: 'Basil 213',
    EndTime: '6:15',
  },
  {
    EventID: '10015',
    EventName: 'Mens Basketball vs Cortland',
    StartTime:'7:00',
    Date: '05/04/2023',
    Location: 'Growney Gym',
    EndTime: '9:30',
  },
  {
    EventID: '10016',
    EventName: 'ENGL 141',
    StartTime:'1:30',
    Date: '05/09/2023',
    Location: 'Basil 121',
    EndTime: '2:30',
  },
{
    EventID: '10017',
    EventName: 'PHIL 461',
    StartTime:'2:15',
    Date: '05/10/2023',
    Location: 'Pioch 118',
    EndTime: '3:15',
  },
{
    EventID: '10018',
    EventName: 'ENGL 161',
    StartTime:'9:45',
    Date: '05/10/2023',
    Location: 'Pioch 131',
    EndTime: '10:45',
  },
{
    EventID: '10019',
    EventName: 'PHIL 422',
    StartTime:'5:10',
    Date: '05/09/2023',
    Location: 'Basil 213',
    EndTime: '6:15',
  },
  {
    EventID: '10020',
    EventName: 'Womens volleyball vs Morrisville',
    StartTime:'7:00',
    Date: '05/08/2023',
    Location: 'Growney Gym',
    EndTime: '9:30',
  },
];

export const scheduleData = [
  {
    Id: 1,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-03-06T15:00:00.000Z',
    EndTime: '2023-03-06T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 3,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-03-08T15:00:00.000Z',
    EndTime: '2023-03-08T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 2,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-03-06T18:00:00.000Z',
    EndTime: '2023-03-06T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 4,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-03-08T18:00:00.000Z',
    EndTime: '2023-03-08T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 5,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-03-07T16:00:00.000Z',
    EndTime: '2023-03-07T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 6,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-03-09T16:00:00.000Z',
    EndTime: '2023-03-09T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 7,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-03-07T20:00:00.000Z',
    EndTime: '2023-03-07T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 8,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-03-09T20:00:00.000Z',
    EndTime: '2023-03-09T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 9,
    Subject: 'Mens Basketball vs Nazreth',
    Location: 'Growney Gym',
    StartTime: '2023-03-06T23:00:00.000Z',
    EndTime: '2023-03-06T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 10,
    Subject: 'Womens Vollyball vs Morrsiville',
    Location: 'Growney Gym',
    StartTime: '2023-03-10T23:00:00.000Z',
    EndTime: '2023-03-10T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 11,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-03-13T15:00:00.000Z',
    EndTime: '2023-03-13T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 12,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-03-15T15:00:00.000Z',
    EndTime: '2023-03-15T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 13,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-03-13T18:00:00.000Z',
    EndTime: '2023-03-13T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 14,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-03-15T18:00:00.000Z',
    EndTime: '2023-03-15T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 15,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-03-14T16:00:00.000Z',
    EndTime: '2023-03-14T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 16,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-03-16T16:00:00.000Z',
    EndTime: '2023-03-16T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 17,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-03-14T20:00:00.000Z',
    EndTime: '2023-03-14T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 18,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-03-16T20:00:00.000Z',
    EndTime: '2023-03-16T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 19,
    Subject: 'WomensBasketball vs Buffalo',
    Location: 'Growney Gym',
    StartTime: '2023-03-13T23:00:00.000Z',
    EndTime: '2023-03-13T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 20,
    Subject: 'Mens Vollyball vs Cortland',
    Location: 'Growney Gym',
    StartTime: '2023-03-17T23:00:00.000Z',
    EndTime: '2023-03-17T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 21,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-03-20T15:00:00.000Z',
    EndTime: '2023-03-20T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 23,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-03-22T15:00:00.000Z',
    EndTime: '2023-03-22T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 22,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-03-20T18:00:00.000Z',
    EndTime: '2023-03-20T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 24,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-03-22T18:00:00.000Z',
    EndTime: '2023-03-22T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 25,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-03-21T16:00:00.000Z',
    EndTime: '2023-03-21T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 26,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-03-23T16:00:00.000Z',
    EndTime: '2023-03-23T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 27,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-03-21T20:00:00.000Z',
    EndTime: '2023-03-21T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 28,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-03-23T20:00:00.000Z',
    EndTime: '2023-03-23T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 29,
    Subject: 'Mens Basketball vs Albany',
    Location: 'Growney Gym',
    StartTime: '2023-03-20T23:00:00.000Z',
    EndTime: '2023-03-20T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 30,
    Subject: 'Womens Vollyball vs JCC',
    Location: 'Growney Gym',
    StartTime: '2023-03-24T23:00:00.000Z',
    EndTime: '2023-03-24T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 31,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-03-27T15:00:00.000Z',
    EndTime: '2023-03-27T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 32,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-03-29T15:00:00.000Z',
    EndTime: '2023-03-29T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 33,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-03-27T18:00:00.000Z',
    EndTime: '2023-03-27T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 34,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-03-29T18:00:00.000Z',
    EndTime: '2023-03-29T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 35,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-03-28T16:00:00.000Z',
    EndTime: '2023-03-28T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 36,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-03-30T16:00:00.000Z',
    EndTime: '2023-03-30T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 37,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-03-28T20:00:00.000Z',
    EndTime: '2023-03-28T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 38,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-03-30T20:00:00.000Z',
    EndTime: '2023-03-30T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 39,
    Subject: 'Womens Lacroess vs Oswego',
    Location: 'Growney Gym',
    StartTime: '2023-03-27T23:00:00.000Z',
    EndTime: '2023-03-27T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 40,
    Subject: 'Mens Vollyball vs MCC',
    Location: 'Growney Gym',
    StartTime: '2023-03-31T23:00:00.000Z',
    EndTime: '2023-03-31T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 41,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-04-03T15:00:00.000Z',
    EndTime: '2023-04-03T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 43,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-04-05T15:00:00.000Z',
    EndTime: '2023-04-05T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 42,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-04-03T18:00:00.000Z',
    EndTime: '2023-04-03T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 44,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-04-05T18:00:00.000Z',
    EndTime: '2023-04-05T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 45,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-04-04T16:00:00.000Z',
    EndTime: '2023-04-04T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 46,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-04-06T16:00:00.000Z',
    EndTime: '2023-04-06T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 47,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-04-04T20:00:00.000Z',
    EndTime: '2023-04-04T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 48,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-04-06T20:00:00.000Z',
    EndTime: '2023-04-06T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 49,
    Subject: 'Mens Basketball vs Nazreth',
    Location: 'Growney Gym',
    StartTime: '2023-04-03T23:00:00.000Z',
    EndTime: '2023-04-03T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 50,
    Subject: 'Womens Vollyball vs Morrsiville',
    Location: 'Growney Gym',
    StartTime: '2023-04-07T23:00:00.000Z',
    EndTime: '2023-04-07T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 51,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-04-10T15:00:00.000Z',
    EndTime: '2023-04-10T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 52,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-04-12T15:00:00.000Z',
    EndTime: '2023-04-12T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 53,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-04-10T18:00:00.000Z',
    EndTime: '2023-04-10T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 54,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-04-12T18:00:00.000Z',
    EndTime: '2023-04-12T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 55,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-04-11T16:00:00.000Z',
    EndTime: '2023-04-11T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 56,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-04-13T16:00:00.000Z',
    EndTime: '2023-04-13T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 57,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-04-11T20:00:00.000Z',
    EndTime: '2023-04-11T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 58,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-04-13T20:00:00.000Z',
    EndTime: '2023-04-13T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 59,
    Subject: 'Womens Basketball vs Buffalo',
    Location: 'Growney Gym',
    StartTime: '2023-04-10T23:00:00.000Z',
    EndTime: '2023-04-10T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 60,
    Subject: 'Mens Vollyball vs Cortland',
    Location: 'Growney Gym',
    StartTime: '2023-04-14T23:00:00.000Z',
    EndTime: '2023-04-14T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 61,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-04-17T15:00:00.000Z',
    EndTime: '2023-04-17T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 63,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-04-19T15:00:00.000Z',
    EndTime: '2023-04-19T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 62,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-04-17T18:00:00.000Z',
    EndTime: '2023-04-17T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 64,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-04-19T18:00:00.000Z',
    EndTime: '2023-04-19T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 65,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-04-18T16:00:00.000Z',
    EndTime: '2023-04-18T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 66,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-04-20T16:00:00.000Z',
    EndTime: '2023-04-20T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 67,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-04-18T20:00:00.000Z',
    EndTime: '2023-04-18T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 68,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-04-20T20:00:00.000Z',
    EndTime: '2023-04-20T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 69,
    Subject: 'Mens Basketball vs Albany',
    Location: 'Growney Gym',
    StartTime: '2023-04-17T23:00:00.000Z',
    EndTime: '2023-04-17T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 70,
    Subject: 'Womens Vollyball vs JCC',
    Location: 'Growney Gym',
    StartTime: '2023-04-21T23:00:00.000Z',
    EndTime: '2023-04-21T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 71,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-04-24T15:00:00.000Z',
    EndTime: '2023-04-24T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 72,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-04-26T15:00:00.000Z',
    EndTime: '2023-04-26T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 73,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-04-24T18:00:00.000Z',
    EndTime: '2023-04-24T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 74,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-04-26T18:00:00.000Z',
    EndTime: '2023-04-26T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 75,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2024-03-25T16:00:00.000Z',
    EndTime: '2023-04-25T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 76,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-04-27T16:00:00.000Z',
    EndTime: '2023-04-27T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 77,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-04-25T20:00:00.000Z',
    EndTime: '2023-04-25T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 78,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-04-27T20:00:00.000Z',
    EndTime: '2023-04-27T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 79,
    Subject: 'Womens Lacroess vs Oswego',
    Location: 'Growney Gym',
    StartTime: '2023-04-24T23:00:00.000Z',
    EndTime: '2023-04-24T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 80,
    Subject: 'Mens Vollyball vs MCC',
    Location: 'Growney Gym',
    StartTime: '2023-04-28T23:00:00.000Z',
    EndTime: '2023-04-28T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 81,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-05-01T15:00:00.000Z',
    EndTime: '2023-05-01T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 83,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-05-03T15:00:00.000Z',
    EndTime: '2023-05-03T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 82,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-05-01T18:00:00.000Z',
    EndTime: '2023-05-01T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 84,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-05-03T18:00:00.000Z',
    EndTime: '2023-05-03T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 85,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-05-02T16:00:00.000Z',
    EndTime: '2023-05-02T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 86,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-05-04T16:00:00.000Z',
    EndTime: '2023-05-04T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 87,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-05-02T20:00:00.000Z',
    EndTime: '2023-05-02T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 88,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-05-04T20:00:00.000Z',
    EndTime: '2023-05-04T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 89,
    Subject: 'Mens Locrosse vs Nazreth',
    Location: 'Growney Gym',
    StartTime: '2023-05-01T23:00:00.000Z',
    EndTime: '2023-05-01T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 90,
    Subject: 'Womens lacrosse vs Morrsiville',
    Location: 'Growney Gym',
    StartTime: '2023-05-05T23:00:00.000Z',
    EndTime: '2023-05-05T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 91,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-05-08T15:00:00.000Z',
    EndTime: '2023-05-08T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 92,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-05-10T15:00:00.000Z',
    EndTime: '2023-05-10T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 93,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-05-08T18:00:00.000Z',
    EndTime: '2023-05-08T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 94,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-05-10T18:00:00.000Z',
    EndTime: '2023-05-10T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 95,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-05-09T16:00:00.000Z',
    EndTime: '2023-05-09T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 96,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-05-11T16:00:00.000Z',
    EndTime: '2023-05-11T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 97,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-05-09T20:00:00.000Z',
    EndTime: '2023-05-09T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 98,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-05-11T20:00:00.000Z',
    EndTime: '2023-05-11T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 99,
    Subject: 'Womens Softball vs Buffalo',
    Location: 'Growney Gym',
    StartTime: '2023-05-08T23:00:00.000Z',
    EndTime: '2023-05-08T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 100,
    Subject: 'Mens Baseball vs Cortland',
    Location: 'Growney Gym',
    StartTime: '2023-05-12T23:00:00.000Z',
    EndTime: '2023-05-12T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 101,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-05-15T15:00:00.000Z',
    EndTime: '2023-05-15T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 103,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-05-17T15:00:00.000Z',
    EndTime: '2023-05-17T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 102,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-05-15T18:00:00.000Z',
    EndTime: '2023-05-15T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 104,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-05-17T18:00:00.000Z',
    EndTime: '2023-05-17T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 105,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-05-16T16:00:00.000Z',
    EndTime: '2023-05-16T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 106,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-05-18T16:00:00.000Z',
    EndTime: '2023-05-18T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 107,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-05-16T20:00:00.000Z',
    EndTime: '2023-05-16T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 108,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-05-18T20:00:00.000Z',
    EndTime: '2023-05-18T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 109,
    Subject: 'Mens Baseball vs Albany',
    Location: 'Growney Gym',
    StartTime: '2023-05-15T23:00:00.000Z',
    EndTime: '2023-05-15T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 110,
    Subject: 'Womens Softball vs JCC',
    Location: 'Growney Gym',
    StartTime: '2023-05-19T23:00:00.000Z',
    EndTime: '2023-05-19T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 111,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-05-22T15:00:00.000Z',
    EndTime: '2023-05-22T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 112,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-05-24T15:00:00.000Z',
    EndTime: '2023-05-24T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 113,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-05-22T18:00:00.000Z',
    EndTime: '2023-05-22T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 114,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-05-24T18:00:00.000Z',
    EndTime: '2023-05-264T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 115,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2024-05-23T16:00:00.000Z',
    EndTime: '2023-05-23T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 116,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-05-25T16:00:00.000Z',
    EndTime: '2023-05-25T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 117,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-05-23T20:00:00.000Z',
    EndTime: '2023-05-23T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 118,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-05-25T20:00:00.000Z',
    EndTime: '2023-05-25T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 119,
    Subject: 'Mens Lacroess vs Oswego',
    Location: 'Growney Gym',
    StartTime: '2023-05-22T23:00:00.000Z',
    EndTime: '2023-05-22T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  
  


  {
    Id: 120,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-06-06T15:00:00.000Z',
    EndTime: '2023-06-06T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 121,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-06-08T15:00:00.000Z',
    EndTime: '2023-06-08T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 122,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-06-06T18:00:00.000Z',
    EndTime: '2023-06-06T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 123,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-06-08T18:00:00.000Z',
    EndTime: '2023-06-08T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 124,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-06-07T16:00:00.000Z',
    EndTime: '2023-06-07T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 125,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-06-09T16:00:00.000Z',
    EndTime: '2023-06-09T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 126,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-06-07T20:00:00.000Z',
    EndTime: '2023-06-07T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 127,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-06-09T20:00:00.000Z',
    EndTime: '2023-06-09T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 128,
    Subject: 'Mens Basketball vs Nazreth',
    Location: 'Growney Gym',
    StartTime: '2023-06-06T23:00:00.000Z',
    EndTime: '2023-06-06T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 129,
    Subject: 'Womens Vollyball vs Morrsiville',
    Location: 'Growney Gym',
    StartTime: '2023-06-05T23:00:00.000Z',
    EndTime: '2023-06-05T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 130,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-06-13T15:00:00.000Z',
    EndTime: '2023-06-13T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 131,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-06-15T15:00:00.000Z',
    EndTime: '2023-06-15T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 132,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-06-13T18:00:00.000Z',
    EndTime: '2023-06-13T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 133,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-06-15T18:00:00.000Z',
    EndTime: '2023-06-15T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 134,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-06-14T16:00:00.000Z',
    EndTime: '2023-06-14T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 135,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-06-16T16:00:00.000Z',
    EndTime: '2023-06-16T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 136,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-06-14T20:00:00.000Z',
    EndTime: '2023-06-14T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 137,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-06-16T20:00:00.000Z',
    EndTime: '2023-06-16T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 138,
    Subject: 'WomensBasketball vs Buffalo',
    Location: 'Growney Gym',
    StartTime: '2023-06-13T23:00:00.000Z',
    EndTime: '2023-06-13T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 139,
    Subject: 'Mens Vollyball vs Cortland',
    Location: 'Growney Gym',
    StartTime: '2023-06-12T23:00:00.000Z',
    EndTime: '2023-06-12T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 140,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-06-20T15:00:00.000Z',
    EndTime: '2023-06-20T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 141,
    Subject: 'SPST 141',
    Location: 'Basil 121',
    StartTime: '2023-06-22T15:00:00.000Z',
    EndTime: '2023-06-22T16:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 142,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-06-20T18:00:00.000Z',
    EndTime: '2023-06-20T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 143,
    Subject: 'CSCI 161',
    Location: 'Pioch 118',
    StartTime: '2023-06-22T18:00:00.000Z',
    EndTime: '2023-06-22T19:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 144,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-06-21T16:00:00.000Z',
    EndTime: '2023-06-21T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 145,
    Subject: 'ENGL 141',
    Location: 'Basil 121',
    StartTime: '2023-06-23T16:00:00.000Z',
    EndTime: '2023-06-23T17:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 146,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-06-21T20:00:00.000Z',
    EndTime: '2023-06-21T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 147,
    Subject: 'PHIL 461',
    Location: 'Pioch 118',
    StartTime: '2023-06-23T20:00:00.000Z',
    EndTime: '2023-06-23T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 148,
    Subject: 'Mens Basketball vs Albany',
    Location: 'Growney Gym',
    StartTime: '2023-06-20T23:00:00.000Z',
    EndTime: '2023-06-20T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 149,
    Subject: 'Womens Vollyball vs JCC',
    Location: 'Growney Gym',
    StartTime: '2023-06-19T23:00:00.000Z',
    EndTime: '2023-06-19T24:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  

  {
    Id: 150,
    Subject: 'Final Exams',
    Location: 'UnKnown',
    StartTime: '2023-06-26T13:00:00.000Z',
    EndTime: '2023-06-26T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 152,
    Subject: 'Final Exams',
    Location: 'UnKnown',
    StartTime: '2023-06-27T13:00:00.000Z',
    EndTime: '2023-06-27T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },{
    Id: 152,
    Subject: 'Final Exams',
    Location: 'UnKnown',
    StartTime: '2023-06-28T13:00:00.000Z',
    EndTime: '2023-06-28T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },{
    Id: 153,
    Subject: 'Final Exams',
    Location: 'UnKnown',
    StartTime: '2023-06-29T13:00:00.000Z',
    EndTime: '2023-06-29T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },{
    Id: 154,
    Subject: 'Final Exams',
    Location: 'UnKnown',
    StartTime: '2023-06-30T13:00:00.000Z',
    EndTime: '2023-06-30T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },

  {
    Id: 155,
    Subject: 'Faculty Analysis',
    Location: 'Basil 121',
    StartTime: '2023-07-06T13:00:00.000Z',
    EndTime: '2023-07-06T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 156,
    Subject: 'Faculty Analysis',
    Location: 'Basil 121',
    StartTime: '2023-07-07T13:00:00.000Z',
    EndTime: '2023-07-07T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
  {
    Id: 156,
    Subject: 'Faculty Analysis',
    Location: 'Basil 121',
    StartTime: '2023-07-07T13:00:00.000Z',
    EndTime: '2023-07-07T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },
 
  {
    Id: 157,
    Subject: 'Faculty Analysis',
    Location: 'Basil 121',
    StartTime: '2023-07-05T13:00:00.000Z',
    EndTime: '2023-07-05T21:00:30.000Z',
    CategoryColor: '#7fa900',
  },

  {
    Id: 158,
    Subject: 'Freshman New Beginnings',
    Location: 'Pioch 118',
    StartTime: '2023-07-14T13:00:00.000Z',
    EndTime: '2023-07-14T21:20:30.000Z',
    CategoryColor: '#7fa900',
  },
 
  {
    Id: 159,
    Subject: 'Event Plannings',
    Location: 'Basil 121',
    StartTime: '2023-07-12T13:00:00.000Z',
    EndTime: '2023-07-12T21:00:00.000Z',
    CategoryColor: '#7fa900',
  },

  {
    Id: 160,
    Subject: 'Summer Faculty Meeting',
    Location: 'Basil 121',
    StartTime: '2023-07-21T13:00:00.000Z',
    EndTime: '2023-07-21T15:00:00.000Z',
    CategoryColor: '#7fa900',
  },
  
];

export const lineChartData = [
  [
    { x: new Date(2023, 10, 11), y: 90 },
    { x: new Date(2023, 10, 11), y: 100 },
    { x: new Date(2023, 10, 11), y: 95 },
    { x: new Date(2023, 10, 11), y: 100 },
    { x: new Date(2023, 10, 11), y: 90 },
    { x: new Date(2023, 10, 11), y: 72 },
    { x: new Date(2023, 10, 11), y: 100 },
  ],
  [
    { x: new Date(2023, 10, 11), y: 100 },
    { x: new Date(2023, 10, 11), y: 82 },
    { x: new Date(2023, 10, 11), y: 100 },
    { x: new Date(2023, 10, 11), y: 60 },
    { x: new Date(2023, 10, 11), y: 88 },
    { x: new Date(2023, 10, 11), y: 100 },
    { x: new Date(2023, 10, 11), y: 84 },
  ],

  [
    { x: new Date(2023, 10, 11), y: 72 },
    { x: new Date(2023, 10, 11), y: 100 },
    { x: new Date(2023, 10, 11), y: 50 },
    { x: new Date(2023, 10, 11), y: 93 },
    { x: new Date(2023, 10, 11), y: 82 },
    { x: new Date(2023, 10, 11), y: 100 },
    { x: new Date(2023, 10, 11), y: 100 },
  ],
];

export const SparklineAreaData = [
  { x: 1, yval: 2 },
  { x: 2, yval: 6 },
  { x: 3, yval: 8 },
  { x: 4, yval: 5 },
  { x: 5, yval: 10 },

];

export const lineCustomSeries = [
  { dataSource: lineChartData[0],
    xName: 'x',
    yName: 'y',
    name: 'CSCI 161',
    width: '2',
    marker: { visible: true, width: 10, height: 10 },
    type: 'Line' },

  { dataSource: lineChartData[1],
    xName: 'x',
    yName: 'y',
    name: 'CSCI 461',
    width: '2',
    marker: { visible: true, width: 10, height: 10 },
    type: 'Line' },

  { dataSource: lineChartData[2],
    xName: 'x',
    yName: 'y',
    name: 'SPST 121',
    width: '2',
    marker: { visible: true, width: 10, height: 10 },
    type: 'Line' },

];

export const kanbanData = [
  {
    Id: 'Task 1',
    Title: 'Task - 29001',
    Status: 'To Do',
    Summary: 'Make mens basketball event vs Albany.',
    Color: '#02897B',
  },
  {
    Id: 'Task 2',
    Title: 'Task - 29002',
    Status: 'To Do',
    Summary: 'Make NURS 100 class on tuesday at 11.',
    Color: '#02897B',
  },
  {
    Id: 'Task 3',
    Title: 'Task - 29003',
    Status: 'To Do',
    Summary: 'Grade chapter 3 test.',
    Color: '#02897B',
  },
  {
    Id: 'Task 4',
    Title: 'Task - 29004',
    Status: 'InProgress',
    Summary: 'Grade homework 5.',
    Color: '#02897B',
  },
  {
    Id: 'Task 5',
    Title: 'Task - 29005',
    Status: 'InProgress',
    Summary: 'Set Womens basketball game for 3/5.',
    Color: '#02897B',
  },
  {
    Id: 'Task 6',
    Title: 'Task - 29006',
    Status: 'Done',
    Summary: 'Create CSCI 161 class',
    Color: '#02897B',
  },
  {
    Id: 'Task 7',
    Title: 'Task - 29007',
    Status: 'Done',
    Summary: 'Set Womens Vollyball game vs Buffalo.',
    Color: '#02897B',
  },
  {
    Id: 'Task 8',
    Title: 'Task - 29008',
    Status: 'Done',
    Summary: 'Make SPST class at 11:30.',
    Color: '#02897B',
  },
  {
    Id: 'Task 9',
    Title: 'Task - 29009',
    Status: 'Done',
    Summary: 'Grab stuff for the barbaque this weekend.',
    Color: '#02897B',
  },
];


